export const updateConfigAction = (configDetails)=>{
     return {type:'UPDATE_CONFIG_DETAILS',payload:configDetails}
}

export const updateConfigData = (resData)=>{
    return{type:'SCCESSFULLY_UPDATE_CONFIG',payload:resData}
}

